<template>
  <div class="collection">
    <div class="collection__header">
      <h1 class="medium-title title">Collection Manager</h1>
      <p class="subhead subtitle">Manage all collection</p>
    </div>
    <div class="collection__menubar">
      <router-link class="subhead title" tag="li" :to="{name: 'collectionlist'}">Collection</router-link>
      <router-link class="subhead title" tag="li" :to="{name: 'collectiongroup'}">Collection Group</router-link>
    </div>
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'adx-collection',
  components: {

  },
  props: {

  },
  data() {
    return {

    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {

  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>